import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { FetchReviewsContext } from 'Shared/api/Reviews.api';

// Actions
import * as reviewActions from 'Shared/actions/Reviews.actions';

// Hooks
import { useToggle } from '../hooks';

type Props = {
  context: FetchReviewsContext;
  reviewCycleSlug?: string;
};

export const useReviewsFetch = ({ context = FetchReviewsContext.feedback_360, reviewCycleSlug }: Props) => {
  const dispatch = useDispatch();

  const [isFetching, toggleIsFetching] = useToggle(true);

  useEffect(() => {
    dispatch(reviewActions.fetchReviews({ context, reviewCycleSlug })).then(() => {
      toggleIsFetching();
    });
  }, []);

  return {
    isFetching,
  };
};
